module.exports = __webpack_public_path__ + "media/images/favicon-fce0ab9bc9af1324fd04341559f62656.svg";